import { render } from "./PagesTitle.vue?vue&type=template&id=6c214a78&scoped=true&ts=true"
import script from "./PagesTitle.vue?vue&type=script&lang=ts"
export * from "./PagesTitle.vue?vue&type=script&lang=ts"

import "./PagesTitle.vue?vue&type=style&index=0&id=6c214a78&lang=scss&scoped=true"

import exportComponent from "C:\\ProjectsLaravel\\nft_imw_v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c214a78"],['__file',"resources/ts/frontend/components/PagesTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c214a78"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c214a78', __exports__)) {
    console.log('reload')
    api.reload('6c214a78', __exports__)
  }
  
  module.hot.accept("./PagesTitle.vue?vue&type=template&id=6c214a78&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('6c214a78', render)
  })

}


export default __exports__